/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {},
        nestedAccordion: {
            paddingLeft: 4
        },
        internalButton: {
            color: 'gray.400'
        },
        internalButtonIcon: {
            color: 'gray.400',
            marginRight: 2
        },
        leafButton: {
            color: 'gray.400',
            paddingTop: 2,
            paddingBottom: 2,
            paddingRight: 0
        },
        leafButtonActive: {
            color: 'white'
        }
    },
    parts: [
        'container',
        'nestedAccordion',
        'internalButton',
        'leafButtonIcon',
        'leafButton',
        'leafButtonActive'
    ]
}
